export default __webpack_public_path__ + "static/media/manifest.fb682c9d.svg";